// extracted by mini-css-extract-plugin
export default {"section":"ListWithOtherOrgsIssues_section__X1FjG","organisations":"ListWithOtherOrgsIssues_organisations__eou6g","organisation":"ListWithOtherOrgsIssues_organisation__GjVjI"};